import React, { Component } from 'react';
import { Button, Dropdown, Tab, Tabs, Nav, Accordion } from 'react-bootstrap';

const SurveyOptionsAll = [
    { id: 1, label: 'PB Residence Field Verification' },
    { id: 2, label: 'CB Residence Field Verification' },
    { id: 3, label: 'PB Employment Field Verification' },
    { id: 4, label: 'CB Employment Field Verification' },
    { id: 5, label: 'PB Business Field Verification' },
    { id: 6, label: 'CB Business Field Verification' },
    { id: 7, label: 'PB Trade Field Verification' },
    { id: 8, label: 'CB Trade Field Verification' },
    { id: 9, label: 'Motor Vehicle Inspection' },
  ];

  const SurveyOptionsPB = [
    { id: 1, label: 'PB Residence Field Verification' },
    { id: 3, label: 'PB Employment Field Verification' },
    { id: 5, label: 'PB Business Field Verification' },
    { id: 7, label: 'PB Trade Field Verification' },
    { id: 9, label: 'Motor Vehicle Inspection' },
  ];
const SurveyType = (props) => {
    console.log(props);

    const handleCheckboxChange = (item) => {
        props.setSelectedSurveys((prev) => {
        const exists = prev.find(p => p.id === item.id);

        if (exists) {
            return prev.filter(p => p.id !== item.id);
        } else {
            return [...prev, { ...item, count: 1, s_id: 1 }];
        }
        });

        // remove/add in surveyDetails
        props.setSurveyDetails((prev) => {
        const exists = prev.find(s => s.survey_type_id === item.id);

        if (exists) {
            return prev.filter(s => s.survey_type_id !== item.id);
        }

        return [
            ...prev,
            {
            id: 1,
            survey_type_id: item.id,
            count: 1,
            survey_details: getSurveyDetails(item, props)
            }
        ];
        });
    };

    const handleCounter = (item, type) => {
        props.setSelectedSurveys((prev) => {
            // get current entries of this survey
            const existing = prev.filter(p => p.id === item.id);

            let count = existing.length;

            if (type === 'inc') count += 1;
            if (type === 'dec' && count > 1) count -= 1;

            // remove old entries of this survey
            const others = prev.filter(p => p.id !== item.id);

            // create new entries with suffix
            const newEntries = Array.from({ length: count }, (_, i) => ({
            s_id: i+1,
            id: item.id,
            label: `${item.label}-${i + 1}`,
            count,
            }));

            // update surveyDetails also
            updateSurveyDetails(item, count);

            return [...others, ...newEntries];
        });
    };

    const updateSurveyDetails = (item, count) => {
        props.setSurveyDetails((prev) => {
        const filtered = prev.filter(s => s.survey_type_id !== item.id);

        let newEntries = [];

        for (let i = 0; i < count; i++) {
            newEntries.push({
            id: i+1,
            survey_type_id: item.id,
            survey_details: getSurveyDetails(item, props)
            });
        }

        return [...filtered, ...newEntries];
        });
    };

    const getSurveyDetails = (item, props) => {
        const isPB = SurveyOptionsPB?.map(v=>v.id).includes(item.id);

        return {
        name: isPB
            ? props.customerDetails?.pb_full_name
            : props.customerDetails?.cb_full_name,
        address: '',
        province_id: null,
        city_id: null,
        other_instruction: '',
        doc_urls: []
        };
    };
    let SurveyOptions = props.customerDetails?.is_co_borrower_enable ? SurveyOptionsAll : SurveyOptionsPB;
    return (
        <div className="image-form-outer">
            <div className="form-tab-right-panel">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>Select Type of Survey</h2>
                    </div>
                    <div className="lead-form-filed">
                        <div className='survey-type-outer'>
                            <ul>
                            {SurveyOptions.map((item) => {
                            const selected = props.selectedSurveys.find(p => p.id === item.id);
                            return(
                                <li key={item.id} className='survey-type-list'>
                                <div className="custom-control custom-checkbox">
                                    <input
                                    type="checkbox"
                                    id={`${item.id}`}
                                    className="custom-control-input"
                                    checked={!!selected}
                                    onChange={() => handleCheckboxChange(item)}
                                    />
                                    <label
                                    className="custom-control-label"
                                    htmlFor={`${item.id}`}
                                    >
                                    {item.label}
                                    </label>
                                </div>

                                {(selected && props.customerDetails?.lead_type === 'if') && (
                                    <div className="counter">
                                    <button onClick={() => handleCounter(item, 'dec')}>-</button>
                                    <span>{selected.count}</span>
                                    <button onClick={() => handleCounter(item, 'inc')}>+</button>
                                    </div>
                                )}
                                </li>
                            )})}
                            </ul>
                            <div className="btn-save-remarks m-lg-t">
                                <button type="button" className="btn-primary" disabled={!props.selectedSurveys?.length} onClick={()=> props.setActiveStep(3)}>Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default SurveyType;